import {property} from '@wonderlandengine/api/decorators.js';
import {SimpleAnimationBase} from './simple-animation-base.js';
import {quat} from 'gl-matrix';
import {Mathf} from '../../utils/Mathf.js';

export class TweenRotationAnimation extends SimpleAnimationBase {
    static TypeName = 'tween-rotation-animation';
    static InheritProperties = true;

    @property.vector3(0, 0, 0)
    from: [number, number, number] = [0, 0, 0];

    @property.vector3(0, 0, 0)
    to: [number, number, number] = [0, 0, 0];

    private _tempvec3: [number, number, number] = [0, 0, 0];
    private _startRotation: quat = quat.create();
    private _tempQuat: quat = quat.create();

    start(): void {
        super.start();
        this.object.getRotationLocal(this._startRotation);
    }

    protected override onLerpUpdate(value: number): void {
        for (let i = 0; i < 3; i++) {
            this._tempvec3[i] = this.from[i] * (1 - value) + this.to[i] * value;
        }
        quat.rotateX(
            this._tempQuat,
            this._startRotation,
            this._tempvec3[0] * Mathf.Deg2Rad
        );
        quat.rotateY(this._tempQuat, this._tempQuat, this._tempvec3[1] * Mathf.Deg2Rad);
        quat.rotateZ(this._tempQuat, this._tempQuat, this._tempvec3[2] * Mathf.Deg2Rad);
        this.object.setRotationLocal(this._tempQuat);
    }
}
